<script>
  import tiposConta from '~js/tipos-conta';
  import tiposPix from '~js/tipos-pix';
  import radio from '~componentes/Radio.vue';
  
  export default {
    components: { radio },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      dadosBancarios: {
        type: Array,
        required: true,
      },
      dadosBancariosPIX: {
        type: Array,
        required: true,
      },
      edicao: Boolean
    },
    data() {
      return {
        tiposPix: tiposPix.filter(p => p.id != -1),
        tiposConta: tiposConta,
        tiposContaAux: tiposConta,
        configuracao: this.$storage.configuracao(),
        tipoContaPix: parseInt(this.solicitacao.tipoConta) === 4 ? 2 : 1,
      }
    },
    methods: {
      validar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        return this.$validator.validateAll();
      },
      nomeTipoConta(tipo) {
        tipo = tipo !== -1 ? tipo : -1;
        if (tipo == -1) {
          return "---";
        } else {
          return this.tiposContaAux.find(tipoConta => {
            return tipoConta.id === tipo;
          }).nome;
        }
      },
      nomeTipoPIX(tipo) {
        return this.tiposPix.find(tipoPIX => {
          return tipoPIX.id === tipo;
        }).nome;
      },
      selecionar(dadoBancario) {
        this.solicitacao.banco = dadoBancario.numeroBanco;
        this.solicitacao.agencia = dadoBancario.numeroAgencia;
        this.solicitacao.contaCorrente = dadoBancario.numeroConta;
        this.solicitacao.tipoPix = '';
        this.solicitacao.chavePix = '';
        this.solicitacao.tipoConta = dadoBancario.tipoConta;
      },
      selecionarPix(dadoBancario) {
        this.solicitacao.tipoPix = dadoBancario.tipoPix;
        this.solicitacao.chavePix = dadoBancario.chavePix;
        this.solicitacao.banco = '';
        this.solicitacao.agencia = '';
        this.solicitacao.conta = '';
        this.solicitacao.tipoConta = 4;
      },
      limparContaPix() {
        this.solicitacao.tipoConta = this.tipoContaPix === 2 ? 4 : '';

        if (this.edicao)
          return;

        this.solicitacao.banco = '';
        this.solicitacao.agencia = '';
        this.solicitacao.conta = '';
        this.solicitacao.tipoPix = '';
        this.solicitacao.chavePix = '';
        this.solicitacao.tipoConta = this.tipoContaPix === 2 ? 4 : '';

        this.$validator.reset();
      },
      limparChavePix() {
        this.solicitacao.chavePix = '';
      },
      setarTipoBancario(tipo) {
        tipo === 4 ? this.$set(this, 'tipoContaPix', 2) : this.$set(this, 'tipoContaPix', 1);
      },
      arrayRemove(arr, value) {
        return arr.filter((el) => {
          return el.id != value;
        });
      },
      aplicaconfiguracaoweb() {
        if (this.configuracao) {
          // Visualização Tipos Contas
          this.tiposConta = this.arrayRemove(this.tiposConta, -1);

          if (!this.configuracao.solReembolsoTipoContaCC)
            this.tiposConta = this.arrayRemove(this.tiposConta, 0);

          if (!this.configuracao.solReembolsoTipoContaCP)
            this.tiposConta = this.arrayRemove(this.tiposConta, 1);

          if (!this.configuracao.solReembolsoTipoContaCS)
            this.tiposConta = this.arrayRemove(this.tiposConta, 2);
        }
      },
    },
    mounted() {
      this.aplicaconfiguracaoweb();
    },
    watch: {
      'tipoContaPix': 'limparContaPix'
    },
    computed: {
      validarConta() {
        if (parseInt(this.solicitacao.formaPagamento) != 0)
          return '';

        if (parseInt(this.tipoContaPix) != 1)
          return '';

        return 'required';
      },
      validarContaRequired() {
        if (parseInt(this.solicitacao.formaPagamento) != 0)
          return false;

        if (parseInt(this.tipoContaPix) != 1)
          return false;

        return true;
      },
      validarPixTipo() {
        if (parseInt(this.solicitacao.formaPagamento) != 0)
          return '';

        if (parseInt(this.tipoContaPix) != 2)
          return '';

        return 'required';
      },
      validarPixRequired() {
        if (parseInt(this.solicitacao.formaPagamento) != 0)
          return false;

        if (parseInt(this.tipoContaPix) != 2)
          return false;

        return true;
      },
      validarPixChave() {
        if (parseInt(this.solicitacao.formaPagamento) != 0)
          return '';

        if (parseInt(this.tipoContaPix) != 2)
          return '';

        switch (parseInt(this.solicitacao.tipoPix)) {
          case 0:
            return 'required|email'
            break;
          case 2:
            return 'required|cpf';
            break;
        }

        return 'required';
      },
      mascaraPixChave() {
        if (parseInt(this.solicitacao.formaPagamento) != 0)
          return '';

        if (parseInt(this.tipoContaPix) != 2)
          return '';

        switch (parseInt(this.solicitacao.tipoPix)) {
          case 1:
            return 'telefone'
            break;
          case 2:
            return 'cpf';
            break;
        }

        return '';
      }
    }
  }
</script>

<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group radios">
          <radio v-model="tipoContaPix"
                 :selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10">
            Conta bancária
          </radio>

          <radio v-model="tipoContaPix"
                 :selected-value="2"
                 type="success"
                 :inline="true"
                 v-if="configuracao.solReembDiariaTipoContaPix">
            PIX
          </radio>
        </div>
      </div>
    </div>

    <div id="contas" v-show="tipoContaPix == 1">
      <div class="table-responsive">
        <table class="table table-hover table-pointer">
          <thead>
            <tr>
              <th>Banco</th>
              <th>Agência</th>
              <th>Número da conta</th>
              <th>Tipo de conta</th>
              <th>Conta padrão</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dadoBancario in dadosBancarios" @click="selecionar(dadoBancario)">
              <td>{{ dadoBancario.numeroBanco }}</td>
              <td>{{ dadoBancario.numeroAgencia }}</td>
              <td>{{ dadoBancario.numeroConta }}</td>
              <td>{{ nomeTipoConta(dadoBancario.tipoConta) }}</td>
              <td>{{ dadoBancario.contaPadrao ? 'Sim' : 'Não' }}</td>
            </tr>
            <tr v-if="dadosBancarios.length === 0">
              <td colspan="5" class="text-center">Nenhum registro encontrado.</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="5"><small>Clique sobre o dado bancário para seleciona-lo.</small></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="row">
        <div class="col-lg-3">
          <div class="form-group" :class="{'required': validarContaRequired,'has-error': errors.has('banco')}">
            <label class="control-label" for="banco">Banco</label>

            <input type="text"
                   class="form-control"
                   id="banco"
                   maxlength="20"
                   v-model="solicitacao.banco"
                   data-vv-name="banco"
                   data-vv-as="banco"
                   v-validate="validarConta">

            <p class="text-danger" v-show="errors.has('banco')">{{ errors.first('banco') }}</p>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="form-group" :class="{'required': validarContaRequired,'has-error': errors.has('agencia')}">
            <label class="control-label" for="agencia">Agência</label>

            <input type="text"
                   class="form-control"
                   id="agencia"
                   maxlength="20"
                   v-model="solicitacao.agencia"
                   data-vv-name="agencia"
                   data-vv-as="agência"
                   v-validate="validarConta">

            <p class="text-danger" v-show="errors.has('agencia')">{{ errors.first('agencia') }}</p>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="form-group" :class="{'required': validarContaRequired,'has-error': errors.has('conta')}">
            <label class="control-label" for="conta">Número da conta</label>

            <input type="text"
                   class="form-control"
                   id="conta"
                   maxlength="20"
                   v-model="solicitacao.contaCorrente"
                   data-vv-name="conta"
                   data-vv-as="número da conta"
                   v-validate="validarConta">

            <p class="text-danger" v-show="errors.has('conta')">{{ errors.first('conta') }}</p>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="form-group" :class="{'required': validarContaRequired,'has-error': errors.has('tipoConta')}">
            <label class="control-label" for="tipo-conta">Tipo de conta</label>

            <select class="form-control"
                    id="tipo-conta"
                    v-model="solicitacao.tipoConta"
                    data-vv-name="tipoConta"
                    data-vv-as="tipo de conta"
                    v-validate="validarConta">
              <option value="">Selecione...</option>
              <option :value="tipoConta.id" v-for="tipoConta in tiposConta">{{ tipoConta.nome }}</option>
            </select>

            <p class="text-danger" v-show="errors.has('tipoConta')">{{ errors.first('tipoConta') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div id="pix" v-show="tipoContaPix == 2">
      <div class="table-responsive">
        <table class="table table-hover table-pointer">
          <thead>
            <tr>
              <th width="300">Tipo pix</th>
              <th>Chave PIX</th>
              <th>Conta padrão</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dadoBancarioPIX in dadosBancariosPIX" @click="selecionarPix(dadoBancarioPIX)">
              <td width="300">{{ nomeTipoPIX(dadoBancarioPIX.tipoPix) }}</td>
              <td>{{ dadoBancarioPIX.chavePix }}</td>
              <td>{{ dadoBancarioPIX.contaPadrao ? 'Sim' : 'Não' }}</td>
            </tr>
            <tr v-if="dadosBancariosPIX.length === 0">
              <td colspan="3" class="text-center">Nenhum registro encontrado.</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3"><small>Clique sobre o dado PIX para seleciona-lo.</small></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="row">
        <div class="col-lg-3">
          <div class="form-group" :class="{'required': validarPixRequired, 'has-error': errors.has('tipoPix')}">
            <label class="control-label" for="tipo-pix">Tipo pix</label>

            <select class="form-control"
                    id="tipo-pix"
                    v-model="solicitacao.tipoPix"
                    data-vv-name="tipoPix"
                    data-vv-as="tipo de pix"
                    v-validate="validarPixTipo"
                    v-on:change="limparChavePix">
              <option value="">Selecione...</option>
              <option :value="tipoPix.id" v-for="tipoPix in tiposPix">{{ tipoPix.nome }}</option>
            </select>

            <p class="text-danger" v-show="errors.has('tipoPix')">{{ errors.first('tipoPix') }}</p>
          </div>
        </div>

        <div class="col-lg-9">
          <div class="form-group" :class="{'required': validarPixRequired,'has-error': errors.has('chave')}">
            <label class="control-label" for="chave">Chave pix</label>

            <input type="text"
                   class="form-control"
                   id="chave"
                   name="chave"
                   v-model="solicitacao.chavePix"
                   data-vv-name="chave"
                   data-vv-as="chave pix"
                   v-mascara="mascaraPixChave"
                   data-vv-rules="validarPixChave"
                   v-validate="validarPixChave">

            <p class="text-danger" v-show="errors.has('chave')">{{ errors.first('chave') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso/componentes/compartilhado/FormDadosBancarios.vue